import BaseModel from './base-model';

/**
 * format:
 * @COMMON_NAME: "TRATO INAPROPIADO"
 * @id: "<number>"
 */
export default class ClaimType extends BaseModel {
  constructor(opts = {}) {
    super(opts);
  }
}
